import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Box } from '@material-ui/core';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';

var useStyles = makeStyles(function (theme) {
  return {
    box: {
      padding: theme.spacing(3, 2, 2, 3),
      textAlign: "center",
      "& a": {
        color: theme.palette.grey[800],
        textDecoration: "underline",
        textDecorationColor: theme.palette.grey[800]
      }
    }
  };
});
var MarkDownText = function MarkDownText(_ref) {
  var bgColor = _ref.bgColor,
    description = _ref.description;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.box,
    bgcolor: bgColor
  }, description && /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
    markdownString: description
  }));
};
MarkDownText.propTypes = {
  bgColor: PropTypes__default.string,
  description: PropTypes__default.string
};

export { MarkDownText, MarkDownText as default };
//# sourceMappingURL=MarkDownText.js.map
